// extracted by mini-css-extract-plugin
export default {"ageLine":"KidsAgesRange_ageLine__2gOsk","countAge":"KidsAgesRange_countAge__OTQjC","text":"KidsAgesRange_text__H2RRx"};